import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { admingetAllCountAction } from '../../../actions/Admin/Home';
import NavMenu from '../sidebar/navBar';
import SideMenu from '../sidebar/SidebarCustom';
import './../App.css';

class AdminHome extends Component {

    constructor(props) { 
        super(props);
        this.state = {
            isOpen: true,
            fieldsList: [],
            code: '',
            fieldSelct: '',
            allUserCount: 0,
            allRecruiterCount: 0,
            allCompanyCount: 0,
            allSendResumeCount: 0,
            userData:JSON.parse(localStorage.getItem('userData')),
            formData: { email: "", password: "" },
        }
    }


    componentWillMount() {
        this.props.admingetAllCountAction();
    }

    componentWillReceiveProps(nextProps) {
       
        if (nextProps && nextProps.allCount && nextProps.allCount.statusCode === 200) {
            this.setState({
                allUserCount: nextProps.allCount.User,
                allRecruiterCount: nextProps.allCount.Recruiter,
                allCompanyCount: nextProps.allCount.Company,
                allSendResumeCount: nextProps.allCount.sendResume,
            })
        }
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    render() {
        const { allUserCount, allRecruiterCount, allCompanyCount, allSendResumeCount} = this.state;
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="admin-wrapper">  
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="dash-box a-color">
                                        <div className="dash-icon dash-icon-color-a"><i className="fa fa-user"></i></div>
                                        <div className="dash-in-block">
                                            <div className="dash-count">{allUserCount}</div>
                                            <div className="dash-name">Total User Count</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="dash-box b-color">
                                        <div className="dash-icon dash-icon-color-b"><i className="fa fa-building"></i></div>
                                        <div className="dash-in-block">
                                            <div className="dash-count">{allCompanyCount}</div>
                                            <div className="dash-name">Total Company</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="dash-box c-color">
                                        <div className="dash-icon dash-icon-color-c"><i className="fa fa-handshake-o"></i></div>
                                        <div className="dash-in-block">
                                            <div className="dash-count">{allRecruiterCount}</div>
                                            <div className="dash-name">Total Recruiter</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="dash-box d-color">
                                        <div className="dash-icon dash-icon-color-d"><i className="fa fa-file-text"></i></div>
                                        <div className="dash-in-block">
                                            <div className="dash-count">{allSendResumeCount}</div>
                                            <div className="dash-name">Total Send Resume</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

        );
    }
}


 function mapStateToProps(state) {
    return {
        allCount:state.AdminHome.response

    };
}


export default withRouter(connect(mapStateToProps, {
    admingetAllCountAction,
})(AdminHome));





// WEBPACK FOOTER //
// ./src/components/Admin/Home/AdminHome.js